// src/lib/previews.js
// ───────────────────────────────────────────────────────────────────────────
// 🖼️ Elección de la imagen de preview a pintar. PURO/testeable.
//
// El original se sube crudo (SheetModal.js:521, sin redimensionar): en producción
// son 1.33 MB de promedio y hasta 50 MB. La CF `generateSheetPreviewVariants`
// deriva dos variantes WebP —thumb 200px y card 600px— y las guarda en campos
// aparte, sin tocar `previewImageFrontUrl`/`previewImageBackUrl`.
//
// EL FALLBACK NO ES OPCIONAL: las 1991 planchas que ya existían no tienen variantes
// hasta que corra el backfill, y una plancha recién guardada tampoco las tiene
// durante el segundo que tarda la CF. Sin la cadena de respaldo, la tabla queda con
// imágenes rotas en ambos casos.
//
// Para el visor a pantalla completa y para el Job Ticket impreso se usa SIEMPRE el
// original: una variante de 200px en papel sale pixelada.
// ───────────────────────────────────────────────────────────────────────────

const CAMPOS = {
  front: { thumb: 'previewThumbFrontUrl', card: 'previewCardFrontUrl', src: 'previewImageFrontUrl' },
  back: { thumb: 'previewThumbBackUrl', card: 'previewCardBackUrl', src: 'previewImageBackUrl' },
};

/** Miniatura (~200px) para filas y listas. Cae a card, y de ahí al original. */
export const previewThumb = (sheet, face = 'front') => {
  const c = CAMPOS[face] || CAMPOS.front;
  return (sheet && (sheet[c.thumb] || sheet[c.card] || sheet[c.src])) || null;
};

/** Imagen mediana (~600px) para tarjetas y el preview grande de piso. Cae al original. */
export const previewCard = (sheet, face = 'front') => {
  const c = CAMPOS[face] || CAMPOS.front;
  return (sheet && (sheet[c.card] || sheet[c.src])) || null;
};

/** El ORIGINAL, sin variantes: visor a pantalla completa, impresión, descarga. */
export const previewOriginal = (sheet, face = 'front') => {
  const c = CAMPOS[face] || CAMPOS.front;
  return (sheet && sheet[c.src]) || null;
};
